<template>
  <v-app>
    <v-main class="auth-background">
      <v-container fluid class="fill-height pa-0">
        <v-row no-gutters justify="center" align="center">
          <v-col cols="12" sm="8" md="6" lg="4" xl="3">
              <RouterView />
              <div class="text-center mt-6">
                <p class="text-body-2 text-medium-emphasis">
                  &copy; {{ new Date().getFullYear() }} - Aplicativo Preço do Gás
                </p>
              </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<style scoped>
.auth-background {
  background-color: #f5f5f5;
  background-image: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%);
}

</style>
